module.exports = __webpack_public_path__ + "img/jupiters-claim.007aa103.png";